import { render, staticRenderFns } from "./table.vue?vue&type=template&id=084c0d0f&"
import script from "./table.vue?vue&type=script&lang=js&"
export * from "./table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('084c0d0f')) {
      api.createRecord('084c0d0f', component.options)
    } else {
      api.reload('084c0d0f', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=084c0d0f&", function () {
      api.rerender('084c0d0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/table/src/table.vue"
export default component.exports